// @flow

import React from 'react';
import { Link } from 'react-router-dom';

import { StyledButton } from '../../../common-utils/styledComponents';

export const BasicButton = ({
  size,
  text,
  onClick,
  disabled = false,
  circular = false,
  compact = false,
  floated = null,
  style = {},
  color = null,
  asLink = false,
}) => (
  <StyledButton
    as={asLink ? Link : null}
    basic={true}
    circular={circular}
    color={color}
    compact={compact}
    disabled={disabled}
    floated={floated}
    onClick={onClick}
    size={size}
    style={{
      ...style,
      pointerEvents: disabled ? 'none' : 'auto',
      opacity: disabled ? 0.45 : 1,
    }}
    type="button"
  >
    {text}
  </StyledButton>
);
